<template>
  <div
    class="ps-border-gray-sm ps-inset-12 max-w-sm mx-auto w-full bg-white shadow-lg rounded-lg pointer-events-auto"
  >
    <div class="flex rounded-lg shadow-xs">
      <div class="w-0 flex-1 p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0 pt-0.5">
            <user-avatar :user="toast.user" class="ps-w-10 ps-h-10 " />
          </div>
          <div class="ml-3 w-0 flex-1">
            <p
              v-if="toast.user"
              class="text-sm leading-5 font-medium text-gray-900 text-left"
            >
              {{ toast.user.provided_name || toast.user.email }}
              <span class="ps-font-normal">{{ toast.action }}</span>
            </p>
            <p
              v-if="toast.title"
              class="mt-1 text-sm leading-5 text-gray-500 text-left"
            >
              {{ toast.title }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex border-l border-gray-200">
        <button
          @click="handleToastTap"
          class="-ml-px flex items-center justify-center w-full border border-transparent rounded-r-lg p-4 text-sm leading-5 font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-indigo-700 active:bg-gray-50 transition ease-in-out duration-150"
        >
          View
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from '@picnic-software/vuex'
import UserAvatar from '@/components/UserAvatar'
export default {
  name: 'TheToast',
  props: {
    toast: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    UserAvatar
  },
  methods: {
    ...mapActions({
      routerCard: 'router/card'
    }),
    handleToastTap() {
      if (this.toast.options && this.toast.options.dot_id) {
        return this.routerCard({
          id: this.toast.options.dot_id,
          tab: this.toast.options.route
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-toast {
  box-shadow: 0 0 0 6px rgba(78, 61, 66, 0.3), 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07) !important;
}
</style>
